'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@inflow/ui/components/button';
import { cn } from '@inflow/ui/lib/utils';
import * as React from 'react';
import { getStoredTheme, isSystemDark, setTheme } from './core';
export function ThemeToggle({ lightContent = _jsx(_Fragment, { children: "\u2600\uFE0F" }), darkContent = _jsx(_Fragment, { children: "\uD83C\uDF19" }), className = '', }) {
    const [dark, setDark] = React.useState(null);
    React.useEffect(() => {
        const stored = getStoredTheme();
        setDark(stored ? stored === 'dark' : isSystemDark());
    }, []);
    const onClick = () => {
        const effectiveDark = dark ?? isSystemDark();
        const next = effectiveDark ? 'light' : 'dark';
        setTheme(next); // persist "light"/"dark" to localStorage("theme")
        setDark(!effectiveDark); // update state so UI re-renders
    };
    // Pick the right content explicitly in JS
    const content = dark ? darkContent : lightContent;
    return (_jsx(Button, { type: "button", variant: "ghost", size: "icon", "aria-label": "Toggle theme", ...(dark !== null ? { 'aria-pressed': dark } : {}), onClick: onClick, className: cn('color-foreground', className), children: content }));
}
